import { useSelector } from 'react-redux';
export const useSelectIsAppLoading = () => useSelector(state => state.loading);
export const useSelectFeatures = () => useSelector(state => state.features);
export const useSelectSettings = () => useSelector(state => state.settings);
export const useSelectSiteConfig = () => useSelector(state => state.siteConfig);
export const useSelectNamespace = () => useSelector(state => state?.applicationContext?.applicationName);
// legacy exports (incorrect hook shape)
export const selectIsAppLoading = useSelectIsAppLoading;
export const selectFeatures = useSelectFeatures;
export const selectSettings = useSelectSettings;
export const selectSiteConfig = useSelectSiteConfig;
export const selectNamespace = useSelectNamespace;
